var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ flex: _vm.inline }},[_c('div',{staticClass:"mb-0 font-bold",class:{ 'self-center mr-2': _vm.inline }},[_vm._v("\n    "+_vm._s(_vm.text)+" "+_vm._s(_vm.requiredMarker)+"\n  ")]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }